import { inject, Injectable } from '@angular/core';

import { NewsItem } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { NewsSlideBuilder } from '../../slides/news-slide.builder';
import { BuildContextModel, FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class NewsContentProvider implements ContentProvider<NewsItem> {
  private readonly builder = inject(NewsSlideBuilder);

  public readonly kind = ContentKind.News;
  public readonly tier = RefreshTier.Main;
  public readonly order = 10;
  public readonly presentation = PresentationSlot.Playlist;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public fetch(context: FetchContextModel): Promise<NewsItem[]> {
    return context.source.loadNews(context.config.channel, context.signal);
  }

  public toSlides(items: NewsItem[], context: BuildContextModel): RuntimeSlideModel[] {
    return this.builder.build(items, context.config);
  }
}
